var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_17036)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.447266,
    y: 0.520508,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4473 12.5205C9.89498 12.5205 9.44727 12.0728 9.44727 11.5205L9.44727 5.52051C9.44727 4.96822 9.89498 4.52051 10.4473 4.52051C10.9996 4.52051 11.4473 4.96822 11.4473 5.52051L11.4473 11.5205C11.4473 12.0728 10.9996 12.5205 10.4473 12.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94727 15.0205C8.94727 14.1921 9.61884 13.5205 10.4473 13.5205C11.2757 13.5205 11.9473 14.1921 11.9473 15.0205C11.9473 15.8489 11.2757 16.5205 10.4473 16.5205C9.61884 16.5205 8.94727 15.8489 8.94727 15.0205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_17036"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.447266,
    y: 0.520508,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.d494a95ee36abb514b538fdf4a311c73.svg";
export { ForwardRef as ReactComponent };